module.exports = __webpack_public_path__ + "img/fw-main.9eabe2d8.png";